import { getMethod, patchMethod, postMethod } from '../../common/api';

export const queryUserIdBySlug = async (slug) => {
  const response = await getMethod(`/api/profile-slug/user/${slug}`);
  return response.data.userId;
};

export const checkSlugUnique = async (slug) => {
  const response = await getMethod(`/api/profile-slug/unique/${slug}`);
  return response.data;
};

export const updateUserProfile = async (updateParams, queryParams) => {
  return patchMethod('/api/profile-slug/user', { updateParams, queryParams });
};

export const createUserProfileSlug = async () => {
  return postMethod('/api/profile-slug', {});
};
